'use client';

import dynamic from 'next/dynamic';

const DynamicRequestWidget = dynamic(
    () => import('./request-widget'), // مسیر را نسبت به این فایل جدید تنظیم کنید
    { 
        ssr: false, 
        loading: () => null, 
    }
);

export default function RequestWidgetLoader() {
    return <DynamicRequestWidget />;
}